import { Debug } from '../../components/Debug';
import { Header } from '../../components/Header';
import { DesignersList } from '../../components/DesignersList';
import { Carousel } from '../../components/Carousel';
import { LightGallery } from '../../components/LightGallery';
import { Account } from '../../components/Account';
import { Aside } from '../../components/Aside';
import { List } from '../../components/List';
import { Search } from '../../components/Search';
import { Toast } from '../../components/Toast';
import { CategoryList } from '../../components/CategoryList';
import { Thumbnails } from '../../components/Thumbnail';
import { Grid } from '../../components/Grid';
(new Debug()).init();
(new Header()).init();
(new DesignersList()).init();
(new Carousel()).init();
(new LightGallery()).init();
(new Account()).init();
(new List()).init();
(new Aside()).init();
(new Search()).init();
(new Toast()).init();
(new CategoryList()).init();
(new Grid()).init();
(new Thumbnails()).init();
